import React, { memo } from 'react'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import LoginForm from '../LoginForm'
import etusivu from './img/etusivu_2025.webp'
import './styles.scss'

const LoginPage = () => {
  return (
    <div id="login-container">
      <div className="frontpage-left-content">
        <LoginForm />
        <div className="login-form-container">
          <div>
            <h2 className="login-page-h2">Rekisteröidy tai kokeile</h2>
            <p className="login-page-p" style={{ lineHeight: '1.25' }}>
              Jos sinulla ei ole tunnusta työkaluun, rekisteröi tunnukset tästä. Voit
              myös kokeilla työkalua ilman kirjautumista. Kokeilukirjaa ei voi
              tallentaa tai lähettää.
            </p>
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
            }}
          >
            <Link
              className="link-button login-page-button login-button register-link new-tab-link"
              to="/rekisteroidy"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="icon-button-content">
                <FontAwesomeIcon icon={['far', 'edit']} className="info-icon" />
                Rekisteröidy
                <FontAwesomeIcon
                  icon={['fas', 'external-link-alt']}
                  className="new-tab-icon"
                  aria-hidden="true"
                />
                <span className="new-tab-hint">avautuu uuteen välilehteen</span>
              </div>
            </Link>
            <Link className="link-button login-page-button" to="/kokeile">
              <div className="icon-button-content">
                <FontAwesomeIcon
                  icon={['fas', 'play-circle']}
                  className="info-icon"
                />
                Kokeile Papuria
              </div>
            </Link>
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
              margin: '1em 0',
            }}
          >
            <a
              href="https://papunet.net/kayttoehdot-ja-selosteet/tietosuojaseloste-papunetin-kuvatyokalujen-kayttajat/"
              target="_blank"
              rel="noopener noreferrer"
              className="link-button new-tab-link"
              style={{ fontSize: '16px' }}
              tabIndex={0}
            >
              Tietosuoja&shy;seloste
              <FontAwesomeIcon
                icon={['fas', 'external-link-alt']}
                className="new-tab-icon"
                aria-hidden="true"
              />
              <span className="new-tab-hint">avautuu uuteen välilehteen</span>
            </a>
          </div>
        </div>
      </div>
      <div className="frontpage-right-content">
        <img
          className="frontpage-image"
          src={etusivu}
          alt="Kuva Papurin käyttöliittymästä, jossa keltainen auringonkukka ja teksti auringonkukka."
          width="100%"
          height="auto"
        />
        <h2>Tervetuloa käyttämään Papuria!</h2>
        <p id="papuri-introduction" className="login-page-p">
          Papuri on ilmainen työkalu, jolla voi tehdä monenlaisia verkkokirjoja.
          Kirjan voi tallentaa myös pdf-tiedostona.
        </p>
        <p className="login-page-p">
          Papurissa on erilaisia sivupohjia, joihin on helppo lisätä tekstiä, kuvia,
          videota sekä ääniä. Käytössä ovat myös kaikki Papunetin kuvapankin kuvat.
        </p>
        <p className="login-page-p">
          Papurilla voi tehdä esimerkiksi kuvakirjoja ja kuvitettuja ohjeita, omia
          tarinoita sekä oppimateriaaleja ja monivalintatehtäviä. Kirjaan voi lisätä
          myös ruudukkopohjaisia kuvasanastoja, joihin voi nauhoittaa äänet Papurin
          omalla ääninauhurilla.
        </p>
        <a
          href="https://papunet.net/kuvatyokalut/papuri-verkkokirjatyokalu/"
          target="_blank"
          rel="noopener noreferrer"
          className="login-page-link new-tab-link"
        >
          Lue lisää Papurista
          <FontAwesomeIcon
            icon={['fas', 'external-link-alt']}
            className="new-tab-icon"
            aria-hidden="true"
          />
          <span className="new-tab-hint">avautuu uuteen välilehteen</span>
        </a>
      </div>
    </div>
  )
}

export default memo(LoginPage)
